import './App.css';
import Header from './components/HeaderX';
import Hero from './components/Hero';
import Services from './components/Services';
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import Elements from './components/Elements';

function App() {
  return (
    <>
      <Header />
      <main className="main">
        <Hero />
        <Services />
        <Contacts />
      </main>
      <Footer />
      <Elements />
    </>
  );
}

export default App;
